<!-- Login Help Component - Modern Bootstrap 5.3.7 -->
<div class="container-fluid py-4">
  <div class="row justify-content-center">
    <div class="col-12 col-sm-8 col-md-6 col-lg-5 col-xl-4">
      
      <!-- Login Help Card -->
      <div class="card shadow-lg border-0 login-help-card">
        <div class="card-body p-4 p-md-5">
          
          <!-- Header -->
          <div class="text-center mb-4">
            <div class="login-help-icon mb-3">
              <i class="fa fa-question-circle fa-3x text-primary"></i>
            </div>
            <h2 class="card-title fw-bold text-dark mb-3">
              {{ 'LOGIN_HELP.TITLE' | translate }}
            </h2>
          </div>
          
          <!-- Instructions -->
          <div class="alert alert-info border-0 bg-light-info mb-4">
            <div class="d-flex align-items-start">
              <i class="fa fa-info-circle me-3 mt-1 text-info"></i>
              <p class="mb-0">
                {{ 'LOGIN_HELP.INSTRUCTIONS' | translate }}
              </p>
            </div>
          </div>
          
          <!-- Reset Password Form -->
          <form [formGroup]="loginHelpForm" (ngSubmit)="sendEmailResetPassword()" novalidate>
            
            <!-- Email Field -->
            <div class="mb-4">
              <label for="email" class="form-label fw-semibold">
                <i class="fa fa-envelope me-2 text-muted"></i>
                {{ 'LOGIN_HELP.EMAIL_LABEL' | translate }}
              </label>
              <div class="input-group">
                <span class="input-group-text bg-light border-end-0">
                  <i class="fa fa-envelope text-muted"></i>
                </span>
                <input 
                  formControlName="email"
                  type="email" 
                  class="form-control border-start-0 ps-0"
                  id="email" 
                  [placeholder]="'LOGIN_HELP.EMAIL_PLACEHOLDER' | translate"
                  [class.is-invalid]="loginHelpForm.get('email')?.errors && loginHelpForm.get('email')?.touched"
                  autocomplete="off"
                  readonly
                  onfocus="this.removeAttribute('readonly');"
                  aria-describedby="email-error">
              </div>
              <div 
                id="email-error"
                class="invalid-feedback d-block"
                *ngIf="loginHelpForm.get('email')?.touched && loginHelpForm.get('email')?.hasError('required')">
                <i class="fa fa-exclamation-circle me-1"></i>
                {{ 'LOGIN_HELP.EMAIL_REQUIRED' | translate }}
              </div>
              <div 
                class="invalid-feedback d-block"
                *ngIf="loginHelpForm.get('email')?.touched && loginHelpForm.get('email')?.hasError('email')">
                <i class="fa fa-exclamation-circle me-1"></i>
                {{ 'LOGIN_HELP.EMAIL_INVALID' | translate }}
              </div>
            </div>
            
            <!-- Reset Button -->
            <div class="d-grid gap-2 mb-3">
              <button 
                type="submit" 
                class="btn btn-primary btn-lg fw-semibold"
                [disabled]="!loginHelpForm.valid || processing"
                [attr.aria-label]="'LOGIN_HELP.RESET_BUTTON' | translate">
                <span *ngIf="processing" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                <i *ngIf="!processing" class="fa fa-paper-plane me-2"></i>
                {{ 'LOGIN_HELP.RESET_BUTTON' | translate }}
              </button>
            </div>
            
          </form>
          
          <!-- Success Message -->
          <div class="alert alert-success border-0 bg-light-success mb-4" *ngIf="emailSent">
            <div class="d-flex align-items-start">
              <i class="fa fa-check-circle me-3 mt-1 text-success"></i>
              <div>
                <p class="mb-1 fw-semibold">{{ 'LOGIN_HELP.SUCCESS_TITLE' | translate }}</p>
                <p class="mb-0 small">{{ 'LOGIN_HELP.SUCCESS_MESSAGE' | translate }}</p>
              </div>
            </div>
          </div>
          
          <!-- Back to Login -->
          <hr class="my-4">
          <div class="text-center">
            <!-- <p class="mb-3 text-muted small">Remember your password?</p> -->
            <div class="d-grid d-md-flex justify-content-md-center gap-2">
              <a 
                [routerLink]="['/login']"
                class="btn btn-outline-secondary fw-semibold"
                [attr.aria-label]="'LOGIN_HELP.BACK_TO_LOGIN' | translate">
                <i class="fa fa-arrow-left me-2"></i>
                {{ 'LOGIN_HELP.BACK_TO_LOGIN' | translate }}
              </a>
              <a 
                [routerLink]="['/contact-us']"
                class="btn btn-outline-info fw-semibold"
                [attr.aria-label]="'LOGIN_HELP.CONTACT_SUPPORT' | translate">
                <i class="fa fa-life-ring me-2"></i>
                {{ 'LOGIN_HELP.CONTACT_SUPPORT' | translate }}
              </a>
            </div>
          </div>
          
        </div>
      </div>
      
    </div>
  </div>
</div>
  